import type { Country } from './common';

/**
 * https://en.wikipedia.org/wiki/National_identification_number#Finland
 */
export class FI implements Country {
	private static readonly CHECK_SUM_CHAR = '0123456789ABCDEFHJKLMNPRSTUVWXY';
	private static readonly VALIDATION_REGEX = /^[0-9]{6}[-+A][0-9]{3}[0-9A-Z]$/i;

	/** `DDMMYY-XXXX`, the century separator is part of the number */
	public readonly minLength = 11;

	public validate(input: string): boolean {
		const normalized = this.normalize(input);

		if (!FI.VALIDATION_REGEX.test(normalized)) return false;

		// Validate checksum character
		const mod = parseInt(normalized.substring(0, 6) + normalized.substring(7, 10)) % 31;
		if (normalized[normalized.length - 1] !== FI.CHECK_SUM_CHAR[mod]) return false;

		return true;
	}

	public normalize(input: string): string {
		return input.toUpperCase();
	}

	public getDateOfBirth(input: string): Date | null {
		if (!this.validate(input)) return null;

		const dateOfBirth = this.normalize(input).slice(0, 8);
		let century = '18';

		if (dateOfBirth.includes('-')) {
			century = '19';
		} else if (dateOfBirth.includes('A')) {
			century = '20';
		}

		const year = +`${century}${dateOfBirth.slice(4, 6)}`;
		const month = +dateOfBirth.slice(2, 4);
		const day = +dateOfBirth.slice(0, 2);

		return new Date(year, month - 1, day, 0, 0, 0, 0);
	}
}
